import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=6fcda6e4"
import script from "./Reviews.vue?vue&type=script&lang=ts"
export * from "./Reviews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports